import Model from "./abstract/Model";

export const LocationType = {
  CUSTOMER: 'CUSTOMER',
  DEPOT: 'DEPOT',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN'
};

export const ContractStatusType = {
  TYPE_BOOKED_MAIL_FAILED: 'BOOKED_MAIL_FAILED',
  TYPE_BOOKED: 'BOOKED',
  TYPE_DRIVING: 'DRIVING',
  TYPE_VEHICLE_SIGNED_OFF: 'VEHICLE_SIGNED_OFF',
  TYPE_RETURNED_TO_DEPOT: 'RETURNED_TO_DEPOT',
  TYPE_AUTORESET_TRANSPORT: 'AUTORESET_TRANSPORT',
  TYPE_CANCELLED_TRANSPORT: 'CANCELLED_TRANSPORT',
  TYPE_NOT_READY_FOR_INVOICING: 'NOT_READY_FOR_INVOICING',
  TYPE_READY_FOR_INVOICING: 'READY_FOR_INVOICING',
  TYPE_PRO_FORMA_INVOICE: 'PRO_FORMA_INVOICE',
  TYPE_CANCELLED: 'CANCELLED',
  TYPE_NO_SHOW: 'NO_SHOW',
  TYPE_TRANSFERRED_TO_FIDRON: 'TRANSFERRED_TO_FIDRON',
  TYPE_ARCHIVED: 'ARCHIVED',
  TYPE_WAITING_DEPLOYMENT_DEPOT_INFO: 'WAITING_DEPLOYMENT_DEPOT_INFO',
  TYPE_WAITING_RETURN_DEPOT_INFO: 'WAITING_RETURN_DEPOT_INFO',
}

const FRONTEND_CONTRACT_STATUSES = [
  ContractStatusType.TYPE_BOOKED,
  ContractStatusType.TYPE_BOOKED_MAIL_FAILED,
  ContractStatusType.TYPE_DRIVING,
  ContractStatusType.TYPE_VEHICLE_SIGNED_OFF,
  ContractStatusType.TYPE_RETURNED_TO_DEPOT,
  ContractStatusType.TYPE_CANCELLED,
]

export default class ContractStatus extends Model {

  constructor(props) {
    super();

    this.initializeAttributes(props);
  }

  isCancelled() {
    return this.type == ContractStatusType.TYPE_CANCELLED;
  }

  isActive() {
    return FRONTEND_CONTRACT_STATUSES.includes(this.type) && !this.isCancelled();
  }

  get frontend_name() {
    const type = FRONTEND_CONTRACT_STATUSES.includes(this.type) ? this.type : ContractStatusType.TYPE_ARCHIVED;
    return i18n.database.table.contract_statuses.type[type];
  }

  // get name() {
  //   if (!this.type) return;
  //   return i18n.database.table.contract_statuses.type[this.type.toLowerCase()];
  // }
}
